<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="print:hidden group bg-[#0F172A] text-gray-50 dark:bg-default"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center h-20 p-6 pb-0 mb-6 sm-">
      <img
        [ngClass]="{ 'w-20': isLogoIso, 'w-50': !isLogoIso }"
        class="dark:flex m-auto max-h-20"
        src="{{ logo }}"
        alt="Logo"
      />
    </div>
    <form
      [formGroup]="form"
      [ngClass]="{
        'opacity-100': navigationAppearance === 'default',
        'opacity-0 group-hover:opacity-100': navigationAppearance === 'dense'
      }"
      class="pt-4 px-4 transition-all duration-300 flex gap-x-4 relative items-center"
    >
      <div class="flex relative items-center justify-end">
        <input
          placeholder="Buscar en el menu..."
          formControlName="search"
          class="rounded-sm text-lg py-2 pr-6 px-1 border-b-2 border-b-primary mr-auto"
          matInput
          type="text"
        />
        <mat-icon
          class="absolute z-10 pr-2 h-8 w-8 text-primary"
          [svgIcon]="'heroicons_outline:search'"
        ></mat-icon>
      </div>
    </form>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0" [class.has-test-environment]="!isProduction">
  <!-- Header -->
  <div
    class="sticky top-0 flex flex-0 items-center w-full h-12 px-4 md:px-6 z-50 shadow dark:shadow-none dark:border-b bg-card dark:bg-default print:hidden"
  >
    <div class="flex items-center pr-2 gap-x-2">
      <!-- Navigation toggle button -->
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
      <!-- Navigation appearance toggle button -->
      <button
        class="hidden md:inline-flex"
        mat-icon-button
        (click)="toggleNavigationAppearance()"
      >
        <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
      </button>
      <button
        *ngIf="config.scheme === 'dark'"
        class="hidden md:inline-flex"
        mat-icon-button
        (click)="setScheme('light')"
      >
        <mat-icon>light_mode</mat-icon>
      </button>
      <button
        *ngIf="config.scheme === 'light'"
        class="hidden md:inline-flex"
        mat-icon-button
        (click)="setScheme('dark')"
      >
        <mat-icon>dark_mode</mat-icon>
      </button>
    </div>
    <div class="hidden sm:flex flex-1 justify-center min-w-0 px-2 lg:flex-none lg:px-0 lg:absolute lg:left-1/2 lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2">
      <global-search class="block w-full max-w-lg lg:w-96 xl:w-[32rem]"></global-search>
    </div>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <a
        class="text-primary"
        [href]="appConfigConstant.manualUrl"
        target="_blank"
        mat-stroked-button
      >
        <mat-icon class="text-primary">file_download</mat-icon>
        <span>Descargar manual</span>
      </a>
      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <user></user>
    </div>
  </div>
  <!-- Deploy version banner -->
  <deploy-banner></deploy-banner>

<div
  *ngIf="!isProduction"
  class="sticky top-12 z-49 bg-[#FEE8E2] dark:bg-[#56403F] border-b-2 border-orange-500 text-orange-800 dark:text-orange-300 py-2 font-semibold flex items-center justify-center"
>
  <span class="relative">
    <mat-icon class="absolute right-full top-1/2 -translate-y-1/2 mr-2 !w-5 !h-5 text-orange-800 dark:text-orange-300 ">warning_amber</mat-icon>
    AMBIENTE DE PRUEBAS
  </span>
</div>
  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <div
    class="pt-1 relative flex flex-0 items-center lg:flex-row flex-col lg:justify-between w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
  >
    <span class="font-medium text-secondary">
      {{ companyConfigConstant.name }} &copy; {{ currentYear }}
    </span>
    <span class="font-medium text-secondary">
      Platino Software &copy; | v{{ appVersion }}
    </span>
  </div>
</div>
